/**
 * 06/mai/26 — Normalização de nomes de pessoa física.
 *
 * Convenção (ADR-001 PF): primeiro nome e sobrenome em Title Case, com
 * preposições brasileiras em minúsculas. Empresas seguem outra regra
 * (ALL UPPERCASE) e devem usar `.toUpperCase()`/`getCompanyDisplayName`.
 *
 * Lista de preposições baseada nos sobrenomes brasileiros mais comuns +
 * partículas estrangeiras frequentes em famílias brasileiras (di/von/van/del).
 */

const PREPOSITIONS = new Set([
  'de', 'da', 'do', 'das', 'dos',
  'e', 'em', 'com',
  'del', 'di', 'von', 'van',
]);

export function formatPersonName(name) {
  if (name == null) return '';
  const str = String(name).trim();
  if (!str) return '';
  return str
    .split(/\s+/)
    .map((word, idx) => {
      const lower = word.toLowerCase();
      // Preposição NUNCA inicia o nome (primeira palavra sempre capitalizada).
      if (idx > 0 && PREPOSITIONS.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}

/**
 * Versão composta — útil para exibir nome completo a partir de first/last.
 */
export function formatFullPersonName(first, last) {
  const f = formatPersonName(first);
  const l = formatPersonName(last);
  return [f, l].filter(Boolean).join(' ');
}
